import { Link, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

function PaymentPolicy() {
  const { t } = useTranslation();
  const paragraphs = t("paymentPolicy.paragraphs", "", { returnObjects: true });
  return (
    <Stack spacing={2} padding={6} textAlign="left" alignItems="center">
      <Typography variant="h3" textAlign="center" paddingBottom="1em">
        {t("paymentPolicy.title")}
      </Typography>
      {Array.isArray(paragraphs) &&
        paragraphs.map((paragraph: string, idx: number) => (
          <Typography key={idx} width="80%">
            {paragraph}
          </Typography>
        ))}
      <Typography width="80%">
        <Link href={t("paymentPolicy.paytrailUrl")}>
          {t("paymentPolicy.paytrailUrl")}
        </Link>
      </Typography>
    </Stack>
  );
}

export default PaymentPolicy;
